import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTrendingUp, FiEye, FiMessageCircle } = FiIcons;

const DesignPower = () => {
  const features = [
    {
      icon: FiTrendingUp,
      title: 'Brand strategy',
      description: 'Brand equity audit, Brand positioning, Brand identity system, Brand guidelines, Strategic direction'
    },
    {
      icon: FiEye,
      title: 'Brand identity',
      description: 'Visual positioning, Brand identity system, Brand naming, Logo & visual identity, Brand application'
    },
    {
      icon: FiMessageCircle,
      title: 'Communication strategy',
      description: 'Brand story, Brand messaging, Content marketing, Communication campaigns'
    }
  ];

  return (
    <section className="py-20 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            The power of design
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            We work with forward-thinking brands across all industries. From understanding brand positioning and 
            target audience to creating strategic communication plans that drive engagement and growth.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              className="text-center group"
            >
              <div className="relative mb-6">
                <img 
                  src={`https://images.unsplash.com/photo-${1560472354 + index}?w=200&h=200&fit=crop`} 
                  alt={feature.title}
                  className="w-32 h-32 rounded-full mx-auto object-cover"
                />
                <div className="absolute inset-0 bg-purple-500/20 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <SafeIcon icon={feature.icon} className="h-8 w-8 text-purple-600" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="text-center mt-12"
        >
          <p className="text-gray-500 text-sm">Designed from: England</p>
        </motion.div>
      </div>
    </section>
  );
};

export default DesignPower;